import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export default (t, { model_app }) => {
  const btn_list: BtnListConfig = [
    {
      name: '修改',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '修改数据源',
        component: 'syncDataSourceConfig',
        init_data: {
          form_type: 'edit',
          model_app: model_app,
        },
      },
      authority: `${model_app}/update_sync_data_source`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
    {
      name: '连接测试',
      model_kind: 'confirm',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '连接测试',
        content: '是否确认要进行连接测试',
        ok_url: `${model_app}/data_source_check_connect`,
        api_fields: {
          data_source_id: 'id',
        },
      },
      order: 4,
      authority: `${model_app}/data_source_check_connect`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
          {
            flag: 'source_type',
            type: 'string',
            operator: 'eq',
            value: ['db'],
          },
        ],
      ],
    },
    {
      name: 'AI模型生成',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: 'AI模型生成',
        component: 'aiGenModel',
        init_data: {
          model_app: model_app,
        },
      },
    },
  ];
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '新建数据源',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '新建配置',
        component: 'syncDataSourceConfig',
        init_data: {
          form_type: 'create',
          model_app: model_app,
        },
      },
      authority: `${model_app}/create_sync_data_source`,
    },
  ];
  return {
    head_btn_list: head_btn_list,
    btn_list: btn_list,
    is_operation: [false, false, true, true],
  };
};
